

import Vue from "vue";
import {IPaginationData} from "@/utils/browse/pagination-data";
import {CRM} from "@/models/crm";
import {Company} from "@/models/company";
import {CompanyService} from "@/services/company-service";
import {CompanyDidNotPurchaseReasons, DidNotPurchaseReason} from "@/models/company-did-not-purchase-reason";
import AppSelectCompanyDidNotPurchaseReason from "@/components/company/SelectCompanyDidNotPurchaseReason.vue";
import AppSelectDiscoveredUsFrom from"@/components/company/SelectDiscoveredUsFrom.vue";
import {DiscoveredUsFrom} from "@/models/discovered-us-from";
export default Vue.extend({
	data() {
		return {
			pagination: {
				limit: 100,
				offset: 0,
				order: "id",
				ascending: false
			} as IPaginationData,
			items: [] as CRM[],
			count: 0,
			createCrm: false,
			didNotPurchaseReasons: [] as DidNotPurchaseReason[],
			didNotPurchaseReasonExplained: "",
			discoveredUsFrom: new DiscoveredUsFrom(),
		};
	},
	props: {
		company: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		discoveredUsFromChanged():boolean {
			if (this.company.discoveredUsFrom == null){
				if (this.discoveredUsFrom.isEmpty()){
					return false;
				}
				return true;
			}
			return JSON.stringify(this.company.discoveredUsFrom.getJSON()) != JSON.stringify(this.discoveredUsFrom.getJSON());
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				if (this.company.discoveredUsFrom != null){
					this.discoveredUsFrom = new DiscoveredUsFrom(this.company.discoveredUsFrom.getJSON());
				}else{
					this.discoveredUsFrom = new DiscoveredUsFrom();
				}
				this.didNotPurchaseReasons = this.company.DidNotPurchaseReasons.map(d=>d.ReasonID).filter(d=>d != DidNotPurchaseReason.MISC);
				this.didNotPurchaseReasonExplained = "";
				let foundReason = this.company.DidNotPurchaseReasons.find(d=>d.ReasonID == DidNotPurchaseReason.MISC);
				if (foundReason) {
					this.didNotPurchaseReasonExplained = foundReason.ExtraData;
				}
			}
		},
		didNotPurchaseReasons(){
			this.saveCompany();
		},
		discoveredUsFromChanged(){
			this.saveCompany();
		}
	},
	methods: {
		async fetch() {
			let result = await CompanyService.getCrms(this.company.id, this.pagination);
			this.items = result.data;
			this.count = result.records;
		},
		timestamp(val: Date): string {
			let days = ["Zo", "Ma", "Di", "Woe", "Do", "Vr", "Za"];
			return days[val.getDay()] + ` ${val.getDate()}/${val.getMonth() + 1}/${val.getFullYear()} ${("0" + val.getHours()).slice(-2)}:${("0" + val.getMinutes()).slice(-2)}`;
		},
		async saveCompany(){
			this.company.DidNotPurchaseReasons = this.didNotPurchaseReasons.map(d=>{
				let reason = new CompanyDidNotPurchaseReasons();
				reason.ReasonID = d;
				return reason;
			});
			if (this.didNotPurchaseReasonExplained) {
				let reason = new CompanyDidNotPurchaseReasons();
				reason.ReasonID = DidNotPurchaseReason.MISC;
				reason.ExtraData = this.didNotPurchaseReasonExplained;
				this.company.DidNotPurchaseReasons.push(reason);
			}
			await CompanyService.updateCompany(this.company);
			if (this.discoveredUsFromChanged){
				this.company.discoveredUsFrom = await CompanyService.setDiscoveredUsFrom(this.company, this.discoveredUsFrom);
				this.discoveredUsFrom = new DiscoveredUsFrom(this.company.discoveredUsFrom.getJSON());
			}
		}
	},
	created() {
		this.fetch();
	},
	components: {
		AppSelectCompanyDidNotPurchaseReason,
		AppSelectDiscoveredUsFrom
	}
});
